import { onMounted, ref, watch } from 'vue';

export const setAttributes = (el = ref(null), attributes = {}) => {
    onMounted(() => {
        Object.keys(attributes).forEach((key) => {
            const ref = attributes[key];
            if (ref.value) el.value.setAttribute(key, ref.value);
        });
    });

    if (process.client) {
        Object.keys(attributes).forEach((key) => {
            const ref = attributes[key];
            watch(ref, (value) => {
                el.value.setAttribute(key, value);
            });
        });
    }
};
